/**
 * @module FE-CU38_サブユーザー権限変更画面
 */
import Header from '../../components/header/Header.vue';
import ListPanel from '../../components/listPanel/ListPanel.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import AlsokPanel from './components/AlsokPanel.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import NormalButton from '../../components/button/Normal.vue';
import CONSTANTS from '../../constants';

const PAGE_ID = 'FE-CU38';

export default {
  name: 'SubUserAuthorityChange',
  components: {
    Header,
    BreadCrumbList,
    ListPanel,
    PcPageTitle,
    AlsokPanel,
    MobileFooter,
    PCFooter,
    NormalButton,
  },
  props: ['subUserId'],
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU38サブユーザー権限変更画面.サブユーザー権限変更'),
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU38サブユーザー権限変更画面.C0001'),
      reloadFlag: false,
      marginBottom: 30,
      panelTitle: {
        place: '',
        type: '',
        typeIsBefore: false,
      },
      displayAreaList: [],
      name: '',
      userId: '',
      authorityList: [],
      excludeFromDisplayArea: {
        id: 1,
        label: '',
        isExclude: false,
      },
      subUserDisplayAreas: [],
      isUserDeletionPrediction: false,
      modified: '',
      currentDisplayType: null,
      width: 0,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU38サブユーザー権限変更画面.サブユーザー権限変更'),
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU38サブユーザー権限変更画面.C0001'
        ),
        panelTitle: {
          place: '',
          type: '',
          typeIsBefore: true,
        },
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * APP_CU3801 初期表示(表示地区)
     * @param {string} param エンドポイント
     * @param {object} queries リクエスト
     * @param {string} method HTTPメソッド
     * @returns {object} レスポンス
     */
    APP_CU3801: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      let hasError = false;
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ(対象地区)
            // apiData = {
            //   contentsInfo: {
            //     // 対象地区情報
            //     displayDistrictInfo: {
            //       displayDistrictNickname: "自宅", // ????? タイトル横
            //       usagePlanId: 0, // 0: オンライン監視プラン 1: 依頼かけつけプラン 2:セルフ監視プラン
            //       customerNumber: "51-1234567", // お客様番号
            //       securityDestinationName: "警備先1", // 警備先名
            //       districtSplitNumber: "0001", // 地区番号
            //       districtSplitName: "地区名1234", // 地区名
            //     },
            //     // サブユーザー情報
            //     subUserInfo: {
            //       mail: "aaaiii@example.com",
            //       name: "警備 太郎A",
            //       isUserDeletionPrediction: true,
            //     },
            //     //サブユーザー権限
            //     subUserAuthority: {
            //       securityOperation: true, // 警備操作
            //       rushOrder: true, // かけつけ依頼
            //       notificationHistory: true, // 通知/通知履歴
            //       deviceControl: true, // 機器制御
            //       contact: true,
            //       nicknameSetting: true,
            //       IDCardKeyInfoSetting: true,
            //       watchOverInfoDeliverySetting: true,
            //       lockUpCheck: true,
            //       targetAtHomeSetting: true,
            //       userManagement: true,
            //       emergencyContact: true,
            //     },
            //     modified: "000-00000-00000",
            //   },
            // };
          },
          (error) => {
            hasError = true;
            this.$_abnormality(error.response.status);
            return;
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      if (hasError) {
        return;
      }

      const targetItem = apiData.contentsInfo.displayDistrictInfo;

      // データ整形
      var labels = {
        usagePlan: '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.利用プラン',
        customerNumber: '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.お客様番号',
        securityDestinationName:
          '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.警備先名',
        districtSplitNumber:
          '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.地区番号',
        districtSplitName: '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.地区名',
        displayDistrictNickname:
          '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.ニックネーム対象地区',
      };
      var targetKeys = [
        'usagePlan',
        'customerNumber',
        'securityDestinationName',
        'districtSplitNumber',
        'districtSplitName',
        'displayDistrictNickname',
      ];

      if (apiData?.contentsInfo?.displayDistrictInfo) {
        labels = {
          usagePlan: '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.利用プラン',
          customerNumber: '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.お客様番号',
          securityDestinationName:
            '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.警備先名',
          districtSplitNumber:
            '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.地区番号',
          districtSplitName: '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.地区名',
        };
        targetKeys = [
          'usagePlan',
          'customerNumber',
          'securityDestinationName',
          'districtSplitNumber',
          'districtSplitName',
        ];
      }

      // ユーザー操作権限のkey
      const targetUserAuthKey = {
        securityOperation: '$vuetify.FECU38サブユーザー権限変更画面.警備操作',
        rushOrder: '$vuetify.FECU38サブユーザー権限変更画面.かけつけ依頼',
        notificationHistory: '$vuetify.FECU38サブユーザー権限変更画面.通知通知履歴',
        deviceContorol: '$vuetify.FECU38サブユーザー権限変更画面.機器制御',
        contact: '$vuetify.FECU38サブユーザー権限変更画面.ALSOKへのお問い合わせ',
        nicknameSetting: '$vuetify.FECU38サブユーザー権限変更画面.ニックネーム設定対象地区',
        IDCardKeyInfoSetting: '$vuetify.FECU38サブユーザー権限変更画面.IDカードキー情報設定',
        watchOverInfoDeliverySetting: '$vuetify.FECU38サブユーザー権限変更画面.見守り情報配信設定',
        lockUpCheck: '$vuetify.FECU38サブユーザー権限変更画面.戸締り確認警報確認',
        targetAtHomeSetting: '$vuetify.FECU38サブユーザー権限変更画面.在宅対象設定',
        userManagement: '$vuetify.FECU38サブユーザー権限変更画面.ユーザー管理',
        emergencyContact: '$vuetify.FECU38サブユーザー権限変更画面.緊急連絡先',
      };
      const planTitles = {
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.オンライン監視プラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
          '$vuetify.コード.利用プランID.依頼かけつけプラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
          '$vuetify.コード.利用プランID.依頼かけつけプラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.セルフ監視プラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
          '$vuetify.コード.利用プランID.セルフ監視プラン',
      };
      // ListPanelコンポーネント用に整形
      Object.keys(targetItem).map((key, index) => {
        if (targetKeys.includes(key)) {
          let text = targetItem[key];
          if (key === 'usagePlan') {
            text = planTitles[targetItem[key]];
          }
          if (key === 'districtSplitNumber') {
            if (targetItem[key] === '    ') {
              text = '$vuetify.FECU38サブユーザー権限変更画面.メイン地区';
            }
            if (targetItem[key] === '') {
              return;
            }
          }
          this.displayAreaList = [
            ...this.displayAreaList,
            { id: index + 1, title: labels[key], text: text },
          ];
        }
      });

      // サブユーザー表示用にデータを設定（ListPanelタイトル）
      this.panelTitle = {
        place: `- ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname}`,
        type: '$vuetify.FECU38サブユーザー権限変更画面.対象地区',
        typeIsBefore: true,
      };
      this.isUserDeletionPrediction = apiData.contentsInfo.subUserInfo.isUserDeletionPrediction;

      this.excludeFromDisplayArea = {
        id: 1,
        isExclude: false,
      };
      this.name = apiData.contentsInfo.subUserInfo.name;
      this.userId = apiData.contentsInfo.subUserInfo.mail;

      Object.keys(apiData?.contentsInfo?.subUserAuthority).map((key, index) => {
        this.authorityList = [
          ...this.authorityList,
          {
            id: index + 1,
            label: targetUserAuthKey[key],
            isChecked: apiData?.contentsInfo?.subUserAuthority[key],
            key: key,
          },
        ];
      });

      this.modified = apiData.modified;

      return apiData;
    },
    /**
     * APP_CU3802 初期表示(カメラ)
     * @param {string} param エンドポイント
     * @param {object} queries リクエスト
     * @param {string} method HTTPメソッド
     * @returns {object} レスポンス
     */
    APP_CU3802: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      let hasError = false;
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ(カメラ)
            // apiData = {
            //   contentsInfo: {
            //     // カメラ情報
            //     cameraInfo: {
            //       displayDistrictFacilityName: "リビング", // ????? タイトル横
            //       usagePlanId: 1, // 0: オンライン監視プラン 1: 依頼かけつけプラン 2:セルフ監視プラン
            //       customerNumber: "51-1234567", // お客様番号
            //       securityDestinationName: "警備先1", // 警備先名
            //       districtSplitNumber: "0001", // 地区番号
            //       districtSplitName: "地区名1", // 地区名
            //       displayDistrictNickname: "自宅", // ニックネーム（対象地区）
            //     },
            //     // サブユーザー情報
            //     subUserInfo: {
            //       mail: "aaaiii@example.com",
            //       name: "警備 太郎B",
            //       isUserDeletionPrediction: true,
            //     },
            //     //サブユーザー権限
            //     subUserAuthority: {
            //       anticrimeCameraVideos: true, // カメラ映像
            //       rushOrder: true, // かけつけ依頼
            //       notificationHistory: true, // 通知/通知履歴
            //       contact: true, // 契約・商品に関するお問い合わせ
            //       nicknameSetting: false, // ニックネーム設定
            //       userManagement: false, // ユーザー管理
            //       emergencyContact: true, // 緊急連絡先
            //     },
            //     modified: "000-00000-00000",
            //   },
            // };
          },
          (error) => {
            hasError = true;
            this.$_abnormality(error.response.status);
            return;
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      if (hasError) return;

      const targetItem = apiData.contentsInfo.cameraInfo;

      // データ整形
      var labels = {
        usagePlan: '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.利用プラン',
        customerNumber: '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.お客様番号',
        securityDestinationName:
          '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.警備先名',
        districtSplitNumber:
          '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.地区番号',
        districtSplitName: '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.地区名',
        displayDistrictNickname:
          '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.ニックネーム対象地区',
      };
      var targetKeys = [
        'usagePlan',
        'customerNumber',
        'securityDestinationName',
        'districtSplitNumber',
        'districtSplitName',
        'displayDistrictNickname',
      ];
      if (apiData?.contentsInfo?.displayDistrictInfo) {
        labels = {
          usagePlan: '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.利用プラン',
          customerNumber: '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.お客様番号',
          securityDestinationName:
            '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.警備先名',
          districtSplitNumber:
            '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.地区番号',
          districtSplitName: '$vuetify.FECU38サブユーザー権限変更画面.対象地区詳細表示領域.地区名',
        };
        targetKeys = [
          'usagePlan',
          'customerNumber',
          'securityDestinationName',
          'districtSplitNumber',
          'districtSplitName',
        ];
      }
      const planTitles = {
        [CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.オンライン監視プラン',
        [CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
          '$vuetify.コード.利用プランID.カメラ依頼かけつけプラン',
        [CONSTANTS.CAMERA_USAGE_PLAN.SELF_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.カメラセルフ監視プラン',
      };
      Object.keys(targetItem).map((key, index) => {
        if (targetKeys.includes(key)) {
          let text = targetItem[key];
          if (key === 'usagePlan') {
            text = planTitles[targetItem[key]];
          }
          if (key === 'districtSplitNumber') {
            if (targetItem[key] === '    ') {
              text = '$vuetify.FECU38サブユーザー権限変更画面.メイン地区';
            }
            if (targetItem[key] === '') {
              return;
            }
          }
          this.displayAreaList = [
            ...this.displayAreaList,
            { id: index + 1, title: labels[key], text: text },
          ];
        }
      });
      this.panelTitle = {
        place: `- ${targetItem.cameraNickName}`,
        type: '$vuetify.FECU38サブユーザー権限変更画面.カメラ',
        typeIsBefore: true,
      };
      this.isUserDeletionPrediction = apiData.contentsInfo.subUserInfo.isUserDeletionPrediction;

      // 氏名・ユーザーID用
      this.name = apiData.contentsInfo.subUserInfo.name;
      this.userId = apiData.contentsInfo.subUserInfo.mail;

      // ユーザー操作権限
      const targetUserAuthKey = {
        anticrimeCameraVideos: '$vuetify.FECU38サブユーザー権限変更画面.カメラ映像',
        rushOrder: '$vuetify.FECU38サブユーザー権限変更画面.かけつけ依頼',
        notificationHistory: '$vuetify.FECU38サブユーザー権限変更画面.通知通知履歴',
        contact: '$vuetify.FECU38サブユーザー権限変更画面.ALSOKへのお問い合わせ',
        nicknameSetting: '$vuetify.FECU38サブユーザー権限変更画面.ニックネーム設定カメラ',
        userManagement: '$vuetify.FECU38サブユーザー権限変更画面.ユーザー管理',
        emergencyContact: '$vuetify.FECU38サブユーザー権限変更画面.緊急連絡先',
      };
      this.excludeFromDisplayArea = {
        id: 1,
        isExclude: false,
      };
      Object.keys(apiData?.contentsInfo?.subUserAuthority).map((key, index) => {
        this.authorityList = [
          ...this.authorityList,
          {
            id: index + 1,
            label: targetUserAuthKey[key],
            isChecked: apiData?.contentsInfo?.subUserAuthority[key],
          },
        ];
      });
      this.modified = apiData.contentsInfo.modified;

      return apiData;
    },
    /**
     * APP_CU3803 サブユーザ権限更新(表示地区)
     * @returns {object} レスポンス
     */
    APP_CU3803: async function () {
      this.$_setLoading(true);

      let param = '/api/subUserAuthorityChange/updateDisplayDistrict';

      const labels = {
        securityOperation: '$vuetify.FECU38サブユーザー権限変更画面.警備操作',
        rushOrder: '$vuetify.FECU38サブユーザー権限変更画面.かけつけ依頼',
        notificationHistory: '$vuetify.FECU38サブユーザー権限変更画面.通知通知履歴',
        deviceContorol: '$vuetify.FECU38サブユーザー権限変更画面.機器制御',
        contact: '$vuetify.FECU38サブユーザー権限変更画面.ALSOKへのお問い合わせ',
        nicknameSetting: '$vuetify.FECU38サブユーザー権限変更画面.ニックネーム設定対象地区',
        IDCardKeyInfoSetting: '$vuetify.FECU38サブユーザー権限変更画面.IDカードキー情報設定',
        watchOverInfoDeliverySetting: '$vuetify.FECU38サブユーザー権限変更画面.見守り情報配信設定',
        lockUpCheck: '$vuetify.FECU38サブユーザー権限変更画面.戸締り確認警報確認',
        targetAtHomeSetting: '$vuetify.FECU38サブユーザー権限変更画面.在宅対象設定',
        userManagement: '$vuetify.FECU38サブユーザー権限変更画面.ユーザー管理',
        emergencyContact: '$vuetify.FECU38サブユーザー権限変更画面.緊急連絡先',
      };

      const subUserAuthority = {};
      this.authorityList.map((item) => {
        Object.keys(labels).map((obj) => {
          if (labels[obj] === item.label) {
            subUserAuthority[obj] = item.isChecked;
          }
        });
      });

      // 対象地区の場合
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        subUserId: this.subUserId ?? this.$store.state.subUserId,
        subUserAuthority: subUserAuthority,
        deleteFlg: this.excludeFromDisplayArea.isExclude,
        modified: this.modified,
      };

      let method = 'post';
      let apiData = true;
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = true;
          },
          (error /* eslint-disable-line */) => {
            if (error.message.includes('400')) {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU38サブユーザー権限変更画面.E0001');
            } else {
              this.$_abnormality(error.response.status);
            }
            apiData = false;
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * APP_CU3804 サブユーザ権限更新(カメラ)
     * @returns {object} レスポンス
     */
    APP_CU3804: async function () {
      this.$_setLoading(true);

      let param = '/api/subUserAuthorityChange/updateCamera';

      const labels = {
        anticrimeCameraVideos: '$vuetify.FECU38サブユーザー権限変更画面.カメラ映像',
        rushOrder: '$vuetify.FECU38サブユーザー権限変更画面.かけつけ依頼',
        notificationHistory: '$vuetify.FECU38サブユーザー権限変更画面.通知通知履歴',
        contact: '$vuetify.FECU38サブユーザー権限変更画面.ALSOKへのお問い合わせ',
        nicknameSetting: '$vuetify.FECU38サブユーザー権限変更画面.ニックネーム設定カメラ',
        userManagement: '$vuetify.FECU38サブユーザー権限変更画面.ユーザー管理',
        emergencyContact: '$vuetify.FECU38サブユーザー権限変更画面.緊急連絡先',
      };

      const subUserAuthority = {};
      this.authorityList.map((item) => {
        Object.keys(labels).map((obj) => {
          if (labels[obj] === item.label) {
            subUserAuthority[obj] = item.isChecked;
          }
        });
      });

      // カメラの場合
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        subUserId: this.subUserId ?? this.$store.state.subUserId,
        deviceID: this.$store.state.deviceID,
        subUserAuthority: subUserAuthority,
        deleteFlg: this.excludeFromDisplayArea.isExclude,
        modified: this.modified,
      };

      let method = 'post';
      let apiData = true;
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = true;
          },
          (error) => {
            if (error.message.includes('400')) {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU38サブユーザー権限変更画面.E0001');
            } else {
              this.$_abnormality(error.response.status);
            }
            apiData = false;
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * おすすめボタン押下処理
     */
    recommendButtonListener: function () {
      if (this.$store.state.currentDisplayType === 1) {
        const recommend = JSON.parse(process.env.VUE_APP_RECOMMEND_SECURITY_UNIT_AUTHORITY_SETTING);
        this.authorityList = [
          {
            id: 1,
            label: '$vuetify.FECU38サブユーザー権限変更画面.警備操作',
            isChecked: recommend.securityOperation,
          },
          {
            id: 2,
            label: '$vuetify.FECU38サブユーザー権限変更画面.かけつけ依頼',
            isChecked: recommend.rushOrder,
          },
          {
            id: 3,
            label: '$vuetify.FECU38サブユーザー権限変更画面.通知通知履歴',
            isChecked: recommend.notificationHistory,
          },
          {
            id: 4,
            label: '$vuetify.FECU38サブユーザー権限変更画面.機器制御',
            isChecked: recommend.deviceControl,
          },
          {
            id: 5,
            label: '$vuetify.FECU38サブユーザー権限変更画面.ALSOKへのお問い合わせ',
            isChecked: recommend.contact,
          },
          {
            id: 6,
            label: '$vuetify.FECU38サブユーザー権限変更画面.ニックネーム設定対象地区',
            isChecked: recommend.nicknameSetting,
          },
          {
            id: 7,
            label: '$vuetify.FECU38サブユーザー権限変更画面.IDカードキー情報設定',
            isChecked: recommend.IDCardKeyInfoSetting,
          },
          {
            id: 8,
            label: '$vuetify.FECU38サブユーザー権限変更画面.見守り情報配信設定',
            isChecked: recommend.watchOverInfoDeliverySetting,
          },
          {
            id: 9,
            label: '$vuetify.FECU38サブユーザー権限変更画面.戸締り確認警報確認',
            isChecked: recommend.lockUpCheck,
          },
          {
            id: 10,
            label: '$vuetify.FECU38サブユーザー権限変更画面.在宅対象設定',
            isChecked: recommend.targetAtHomeSetting,
          },
          {
            id: 11,
            label: '$vuetify.FECU38サブユーザー権限変更画面.ユーザー管理',
            isChecked: recommend.userManagement,
          },
          {
            id: 12,
            label: '$vuetify.FECU38サブユーザー権限変更画面.緊急連絡先',
            isChecked: recommend.emergencyContact,
          },
        ];
      } else if (this.$store.state.currentDisplayType === 2) {
        const recommend_camera = JSON.parse(process.env.VUE_APP_RECOMMEND_CAMERA_AUTHORITY_SETTING);
        this.authorityList = [
          {
            id: 1,
            label: '$vuetify.FECU38サブユーザー権限変更画面.カメラ映像',
            isChecked: recommend_camera.anticrimeCameraVideos,
          },
          {
            id: 2,
            label: '$vuetify.FECU38サブユーザー権限変更画面.かけつけ依頼',
            isChecked: recommend_camera.rushOrder,
          },
          {
            id: 3,
            label: '$vuetify.FECU38サブユーザー権限変更画面.通知通知履歴',
            isChecked: recommend_camera.notificationHistory,
          },
          {
            id: 4,
            label: '$vuetify.FECU38サブユーザー権限変更画面.ALSOKへのお問い合わせ',
            isChecked: recommend_camera.contact,
          },
          {
            id: 5,
            label: '$vuetify.FECU38サブユーザー権限変更画面.ニックネーム設定カメラ',
            isChecked: recommend_camera.nicknameSetting,
          },
          {
            id: 6,
            label: '$vuetify.FECU38サブユーザー権限変更画面.ユーザー管理',
            isChecked: recommend_camera.userManagement,
          },
          {
            id: 7,
            label: '$vuetify.FECU38サブユーザー権限変更画面.緊急連絡先',
            isChecked: recommend_camera.emergencyContact,
          },
        ];
      }
    },
    /**
     * お知らせダイアログ
     */
    async callSaveMessageDialog() {
      await this.$informationDialog('$vuetify.messageDialog.設定が完了しました');

      // OK FE-CU37_ユーザー管理画面に遷移
      this.$store.commit('setBackButtonFlag', { backButtonFlag: true });
      this.$router.back();
    },
    /**
     * 確認ダイアログ
     * @description 「はい」押下後、更新処理を実行
     */
    async callSaveAgreementDialogDialog() {
      const msg =
        this.excludeFromDisplayArea.isExclude && this.isUserDeletionPrediction
          ? '$vuetify.メッセージ一覧.FECU38サブユーザー権限変更画面.C0003'
          : '$vuetify.メッセージ一覧.FECU38サブユーザー権限変更画面.C0002';

      const isYes = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        msg,
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );

      if (isYes) {
        let apiResult = false;
        if (this.currentDisplayType === 1) {
          apiResult = await this.APP_CU3803();
        } else {
          apiResult = await this.APP_CU3804();
        }
        // 更新API成功
        if (apiResult) {
          this.callSaveMessageDialog();
        }
      } else {
        // キャンセル
      }
    },
    /**
     * 戻るボタン押下時の処理
     */
    back: function () {
      this.$router.back();
    },
    /**
     * 画面サイズ変更
     * @param {number} width 画面サイズ
     */
    changeItemLabelWidth(width) {
      this.width = width;
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    this.width =
      this.$mq === 'pc' ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP;

    // 画面サイズ変更
    this.$watch('$mq', function () {
      this.changeItemLabelWidth(
        this.$mq === 'pc'
          ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC
          : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP
      );
    });

    let subUserIdProp = this.subUserId ?? this.$store.state.subUserId;
    if (!subUserIdProp) {
      this.$router.push('/userManagement');
      return;
    }

    this.currentDisplayType = this.$store.state.currentDisplayType;

    if (this.currentDisplayType === 1) {
      // 対象地区の場合
      const method = 'post';
      const param = '/api/subUserAuthorityChange/initDisplayDistrict';
      const queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        subUserId: this.subUserId ?? this.$store.state.subUserId,
      };

      await this.APP_CU3801(param, queries, method);
    } else if (this.currentDisplayType === 2) {
      // カメラの場合
      const method = 'post';
      const param = '/api/subUserAuthorityChange/initCamera';
      const queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        subUserId: this.subUserId ?? this.$store.state.subUserId,
        deviceID: this.$store.state.deviceID,
      };

      await this.APP_CU3802(param, queries, method);
    }

    //警備ユニットと通信しない為、データが揃ってから表示
    this.isShowPage = true;
  },
};
